// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604231533/js/" + chunkId + "." + {"44":"34d8ee1a","225":"43ce3433","481":"5e76b277","486":"30d6f3e7","770":"cfc41000"}[chunkId] + ".0.9016332128397544.chunk.js";
};